import { useContext, useEffect, useRef, useState } from 'react';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import Input from '../../../../components/Inputs/Input';
import Item from '../../../../components/Lists/Item';
import { DropdownsContext, useDropdownConfig } from '../../../../contexts/DropdownsContext';
import './InternalRepair.css';
import { deleteRepairTypes, deleteRepairTypesBySite, getPartRepairSites, getRepairsbySitePart, getRepairTypes, saveSiteRepairTypes } from '../../services/SupplyChainService';
import { HTTP_RESPONSE_CODES, LABELS } from '../../../../globals/globals';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { Subject } from 'rxjs';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import DeletePartDialog from './DeletePartDialog';

export const InternalRepair = ({ onClose, part }) => {

    // const [repairs, setRepairs] = useState([]);
    const [siteRepairs, setSiteRepairs] = useState([]);

    useEffect(() => {
        getPartRepairSites(part.id).then(response => {
            if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                setSiteRepairs(response.data.load.map(i => ({ ...i, tempId: crypto.randomUUID(), isNew: false })));
            }
        })
    }, [part]);
    const listRef = useRef(null);

    const [autoOpenFirst, setAutoOpenFirst] = useState(false);


    useEffect(() => {
        if (autoOpenFirst) {
            listRef.current?.querySelector("summary")?.click();
            listRef.current?.querySelector("summary")?.scrollIntoView();
            setAutoOpenFirst(false);
        }
    }, [autoOpenFirst])

    const addClick = () => {
        setSiteRepairs(prev => [{ locationName: "", siteName: "", type: "", repairTypes: 0, tempId: crypto.randomUUID(), isNew: true }, ...prev])
        setAutoOpenFirst(true)
        // let openEvent = new MouseEvent("click", {
        //     bubbles: false,
        //     cancelable: true,
        //     view: window,
        // });
        // listRef.current?.querySelector("summary")?.dispatchEvent(openEvent);
    }

    const changeNewStatus = (idx) => {
        setSiteRepairs(prev => {
            let copy = [...prev];
            copy[idx] = { ...copy[idx], isNew: false };
            return copy;
        })
    }

    const removeItem = (idx) => {
        setSiteRepairs(prev => prev.slice(0, idx).concat(prev.slice(idx + 1)));
    }


    return (
        <div className='internal-repair-component'>
            <div className='header'>
                <div className='header-content'>
                    <div className='title'>
                        <i className="icon-repair"></i>
                        <b>Internal Repair Capability</b>
                    </div>
                    <div className='part-info'>
                        <div>
                            <span>PN</span>
                            <b>{part.partNumber}</b>
                        </div>
                        <div>
                            <span>PN Description</span>
                            <b>{part.description}</b>
                        </div>

                    </div>

                </div>

                <button className='outlined icon small-size' onClick={onClose}>
                    <i className='icon-cross'></i>
                </button>
            </div>

            <hr></hr>

            <div className='subheader'>
                <div className='left-info'>
                    <i className='icon-map'></i>
                    <i className='count'>5</i>
                    <b>Selected Sites Configuration</b>
                    <button className='outlined icon small-size' onClick={addClick}>
                        <i className='icon-add-new'></i>
                    </button>
                </div>
                <div className='right-info'>
                    {/* <span>
                        AA-Los Angeles International Airport - Pacific Standard Time (PST) GMT+8
                    </span> */}
                </div>
            </div>

            <div className='list' ref={listRef}>
                {siteRepairs?.length > 0 ? <>{
                    siteRepairs.map((r, idx) => <LocationSiteItem removeItem={removeItem} idx={idx} changeNewStatus={changeNewStatus} siteInfo={r} part={part} key={r.tempId} />)
                }</> :
                    <div className='placeholder-component small'>
                        <i>No Sites Configured yet</i>
                    </div>
                }
                {/* <LocationSiteItem repairs={repairs} /> */}
            </div>
        </div>
    )
}

const cancelEventSub = new Subject();

const LocationSiteItem = ({ siteInfo, part, changeNewStatus, idx, removeItem }) => {

    const [editedSiteInfo, setEditedSiteInfo] = useState(siteInfo);
    const [editing, setEditing] = useState(siteInfo.isNew);
    const [siteValue, setSitevalue] = useState(null);
    const [repairs, updateRepairs] = useState([]);
    const [repairBackup, setRepairBackup] = useState([]);
    const { successMsg, warningMsg, infoMsg } = useSnackBar();
    const [repairCount, setRepairCount] = useState(siteInfo.repairTypes ?? 0);     

    useEffect(() => {
        setSitevalue({ id: siteInfo.siteId });
    }, [siteInfo])

    const startEditing = () => {
        setEditing(true);
    }

    const deleteItem = () => {
        infoMsg("Repair configuration discarded");
        removeItem(idx);
    }

    // useEffect(()=>{
    //     if (openStatus) {
    //         // setEditedSiteInfo(prev => ({...prev, repairTypes: repairs.length || siteInfo}))
    //     }
    // },[repairs, openStatus])

    const cancelClick = () => {
        // TODO: discard when version is 0, or restore previous values and siteInfo (ext);
        if (siteInfo.isNew) {
            deleteItem();
            return;
        }
        updateRepairs(repairBackup);
        setSitevalue({ id: siteInfo.siteId });
        setEditedSiteInfo(siteInfo);
        infoMsg('Changes discarded')
        setEditing(false);
    }

    const saveClick = (closeEditing) => {

        if (!editedSiteInfo.locationId) {
            infoMsg("Please select a Location");
            return;
        }
        if (!editedSiteInfo.siteId) {
            infoMsg("Please select a Site");
            return;
        }

        if (repairs.length < 1) {
            infoMsg("Please add repair types before saving");
            return;
        }
        infoMsg("Saving Repair Info")
        // console.warn('try to save', Object.values(repairValues).map(r => ({ ...r, siteId: siteValue.id })));
        saveSiteRepairTypes(repairs.map(r => ({ ...r, siteId: siteValue.id }))).then(response => {
            if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                successMsg("Repair info saved");
                updateRepairs(response.data.load);
                setRepairBackup(response.data.load);
                changeNewStatus(idx);
            } else {
                warningMsg(response.data.message);
            }
        })
        setEditing(!closeEditing);
    }

    const [openStatus, setOpenStatus] = useState(false);

    const deleteAllRepairs = () => {
        deleteRepairTypesBySite(editedSiteInfo.siteId, part.id).then(response => {
            if (response.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
                successMsg("Site Repair Info Deleted");
                removeItem(idx);
            } else {
                warningMsg(response.data.message);
            }
        })
        // TODO: call service to delete all the repairs;
    }

    // const repairCount

    return (<div className='location-site-item-component'>
        <Expandable2 onOpenChange={(e) => setOpenStatus(e)} name="internal-repair-item" summary={

            <Item
                item={{}}
                ribbon={[{
                    when: editing,
                    label: LABELS.EDITION_MODE
                }]}
            >

                <div className='info'>
                    <div>
                        <span>Location</span>
                        <b>{editedSiteInfo?.locationName || "--"}</b>
                    </div>
                    <div>
                        <span>Site</span>
                        <b>{editedSiteInfo?.siteName || "--"}</b>
                    </div>
                    <div>
                        <span>Type</span>
                        <b>{editedSiteInfo?.siteType || "--"}</b>
                    </div>
                    <div>
                        <span>Repair Type</span>
                        <i className="count">{repairCount}</i>
                    </div>
                </div>
                {editing ? <>
                    <MultioptionButton buttons={[
                        { label: 'Save and Finish', icon: "icon-save", id: 'save' },
                        { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
                        { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
                    ]}
                        buttonCallbacks={{
                            'save': () => saveClick(true),
                            'save-continue': () => saveClick(false),
                            'cancel': () => cancelClick()
                        }}

                    ></MultioptionButton>
                </> : <div className="actions">

                    {openStatus ? <button className='transparent'><i className='icon-edit iconbutton' onClick={startEditing}></i></button> : <i className='icon-edit iconbutton' onClick={startEditing}></i>}
                    {/* {JSON.stringify(siteInfo.isNew)} */}
                    {siteInfo.isNew === true ?
                        <i className='icon-delete-new iconbutton' onClick={deleteItem}></i>
                        :
                        <DialogTrigger dialogContent={{
                            component: DeletePartDialog,
                            props: {
                                item: { "Location": editedSiteInfo.locationName, "Site": editedSiteInfo.siteName },
                                message: "Are you sure you want to remove the repair information for this site?",
                                onDelete: deleteAllRepairs

                            }
                        }}>
                            <i className='icon-delete-new iconbutton'></i>
                        </DialogTrigger>
                    }

                </div>}
            </Item>
        }>
            <ItemContent setRepairCount={setRepairCount} cancelSubj={cancelEventSub} editedSiteInfo={editedSiteInfo} setEditedSiteInfo={setEditedSiteInfo} siteInfo={siteInfo} part={part} repairs={repairs} updateRepairs={updateRepairs} updateBackup={setRepairBackup} editing={editing} setEditing={setEditing} siteValue={siteValue} setSitevalue={setSitevalue} />

        </Expandable2>

        {/* <div className='info'>


                <div>
                    <span>Location</span>
                    <b>AA-Los Angeles International Airport</b>
                </div>
                <div>
                    <span>Site</span>
                    <b>Miami Intl WH 12</b>
                </div>
                <div>
                    <span>Type</span>
                    <b>Warehouse</b>
                </div>
            </div>
             */}
    </div>)
}

const ItemContent = ({ open, part, setRepairCount, updateRepairs, repairs, updateBackup, siteInfo, editing, setEditing, siteValue, setSitevalue, editedSiteInfo, setEditedSiteInfo }) => {

    const { setDropdownsData } = useContext(DropdownsContext);
    // const [repairs, setRepairs] = useState([]);
    const locdropdwn = useDropdownConfig(17);
    const sitedropdwn = useDropdownConfig(98);
    const repairdropdwn = useDropdownConfig(95);
    const [siteParams, setSiteParams] = useState([{ "columnName": "accountId", value: localStorage.getItem('u_account_id') }, { "columnName": 'locationId', value: null },  {"columnName": "partId", value: part.id}])
    const { infoMsg, successMsg } = useSnackBar();

    useEffect(() => {
        if (open && (typeof (siteInfo.siteId) === 'number') && typeof (part.id) === 'number') {
            getRepairsbySitePart(part.id, siteInfo.siteId).then(response => {
                if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                    updateRepairs(response.data.load.filter(i => typeof (i.id) == 'number').map(i => ({ ...i, tatEstimated: i.tatStimated ?? i.tatEstimated ?? null })));
                    updateBackup(response.data.load.filter(i => typeof (i.id) == 'number').map(i => ({ ...i, tatEstimated: i.tatStimated ?? i.tatEstimated ?? null })))
                }
            })
        }
    }, [open])

    // useEffect(() => {
    //     updateRepairs(repairs);
    // }, [repairs])

    const addRepair = () => {
        updateRepairs(prev => [{ id: null, tatEstimated: null, tatAverage: null, quantity: null, partId: part.id, siteId: siteInfo.id, repairTypeId: null, isNew: true }, ...prev])
        setRepairCount(prev => prev +1);
    }

    const valueChange = (e, idx) => {
        let { name, value, addEvent } = e;
        if (addEvent) {
            let name2 = addEvent.name;
            let value2 = addEvent.value;
            updateRepairs(prev => {
                let copy = [...prev];
                copy[idx] = { ...copy[idx], [name]: parseInt(value), [name2]: value2 };
                return copy;
            })
            return;
        }
        updateRepairs(prev => {
            let copy = [...prev];
            copy[idx] = { ...copy[idx], [name]: parseInt(value) };
            return copy;
        })
    }

    const dropdownChange = (e) => {
        let { name, value } = e;
        setEditedSiteInfo(prev => ({ ...prev, site: value.name }));
    }

    const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
        setDropdownsData((prevDropdowns) =>
            prevDropdowns.map((filter) => {
                if (filter.id === dropdownId) {
                    return {
                        ...filter,
                        parentValues,
                        dependenciesToUpdate,
                        reload: true,
                    };
                }
                return filter;
            })
        );
    };

    const resetDropdownsReload = () => {
        setDropdownsData((filterState) => {
            if (filterState.length > 0) {
                return filterState.map((e) => {
                    if (e.reload) {
                        return { ...e, reload: false };
                    }
                    return e;
                });
            }
            return filterState;
        });
    };

    const deleteRepair = (repair, idx) => {
        // TODO: execute delete service;
        deleteRepairTypes([repair]).then(response => {
            if (response.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
                successMsg("Repair type removed");
                setRepairCount(prev => Math.max(0, prev-1));
                updateRepairs(prev => prev.filter(r => !(repair.id === r.id)));
            } else {
                warningMsg(response.data.message);
            }
        })

    }

    const discardRepair = (repair, idx) => {
        infoMsg("Repair Type discarded");
        updateRepairs(prev => prev.filter(r => !(repair.id === r.id)));
    }

    useEffect(() => {
        setSiteParams(prev => ([{ "columnName": "accountId", value: localStorage.getItem('u_account_id') }, { "columnName": 'locationId', value: editedSiteInfo.locationId }, {"columnName": "partId", value: part.id}]))
    }, [editedSiteInfo])


    return (
        <div className='item-content'>
            {/* {JSON.stringify(repairBackup)} */}
            <div className='dropdowns'>
                <Dropdowns preSelectValue={editedSiteInfo.locationId} disabled={!editing} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={(loc) => setEditedSiteInfo(prev => ({ ...prev, locationName: loc.name, locationId: loc.id, siteId: null, siteName: "", siteType: "" }))} data={locdropdwn.config}></Dropdowns>
                <Dropdowns optionLabel="name" parameters={siteParams} preSelectValue={editedSiteInfo.siteId} disabled={!editing} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={(site) => { setSitevalue(site); setEditedSiteInfo(prev => ({ ...prev, siteName: site.name, siteId: site.id, siteType: site.site_type ?? "" })) }} data={sitedropdwn.config}></Dropdowns>
            </div>
            <div className='subheader'>

                <b>Repair Type</b>
                {editing && <button onClick={addRepair} disabled={!editing} className='filled small-size'>
                    <span>
                        Add Repair Type
                    </span>
                </button>}
            </div>
            <div className='repairs'>
                {repairs.length > 0 ?
                    repairs.map((repair, idx) =>
                        // <CheckboxField disabled={!editing} onChange={(v) => valueChange(rType.id, { name: "checked", value: v })} checked={repairValues[rType.id]?.checked}>
                        <div className='repair-content' key={idx} onClick={(e) => e.stopPropagation()}>
                            <div className='left'>
                                <Dropdowns disabled={!editing} preSelectValue={repair.repairTypeId} onOptionSelect={(rtype) => valueChange({ name: "repairTypeId", value: rtype.id, addEvent: { name: "repairType", value: rtype.name } }, idx)} optionLabel="name" selectionLabel="name" hideLabel data={repairdropdwn.config} />

                                {/* <b>{rType.name}</b> */}
                            </div>

                            <div className='right'>
                                <b>TAT</b>

                                <div>
                                    <span>Estimated</span>
                                    <Input disabled={!editing} value={repair.tatEstimated || ""} name="tatEstimated" onChange={(e) => valueChange(e.target, idx)} label="" isNumeric />
                                    <span>HR</span>
                                </div>
                                <div>
                                    <span>Average</span>
                                    <Input disabled={!editing} value={repair.tatAverage || ""} name="tatAverage" onChange={(e) => valueChange(e.target, idx)} label="" isNumeric />
                                    <span>HR</span>
                                </div>
                                <div>
                                    <span>Capacity</span>
                                    <Input disabled={!editing} value={repair.quantity || ""} name="quantity" onChange={(e) => valueChange(e.target, idx)} label="" isNumeric />
                                </div>
                                {repair.isNew ?

                                    <i className='icon-delete-new' onClick={() => discardRepair(repair, idx)} >
                                    </i> :
                                    <DialogTrigger dialogContent={{
                                        component: DeletePartDialog,
                                        props: {
                                            item: { "Repair Type": repair.repairType ?? "--", "Estimated Turn Around Time": repair.tatEstimated ?? "--", "Average Turn Around Time": repair.tatAverage ?? "--", "Capacity": repair.quantity ?? "--" },
                                            message: "Are you sure you want to remove this repair type?",
                                            onDelete: () => deleteRepair(repair, idx)
                                        }
                                    }}>
                                        <i className='icon-delete-new iconbutton'></i>
                                    </DialogTrigger>
                                }


                            </div>
                        </div>

                        // </CheckboxField>
                    ) :
                    <div className='placeholder-component small white'>
                        <i>No repair types set</i>
                    </div>
                }

            </div>

        </div>
    )
}